import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, message } from 'antd';

import { queryMaterialBorrowWorkflow, querySaveMaterialBorrow } from '@api/administrative/material';
import Process from '@comm/workflow/Process';
import Modalshortfalls from '@comm/shortfalls';
import { getCompanyList } from '@store/modules/company_list';
import { getExpendType } from '@store/modules/finance/expend_type';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
      shortData: '',
      visible: false,
    };
  }

  componentDidMount() {
    this.materialBorrowWorkflow();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  /**
   * 提交资料借用
   */
  handSubmit = item => {
    this.saveMaterialBorrow(item);
  };

  materialBorrowWorkflow = params => {
    const { instance } = this.state;
    queryMaterialBorrowWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveMaterialBorrow = item => {
    this.setState({ isSubmitting: true });
    querySaveMaterialBorrow(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
        this.setState({ isSubmitting: false });
      } else {
        message.error(res.message);
        this.setState({ isSubmitting: false });
      }
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { dataInfo, isSubmitting, instance, shortData, visible } = this.state;
    return (
      <div>
        <FormBase data={dataInfo} handSubmit={this.handSubmit} isSubmitting={isSubmitting} />
        <Card>
          <Process instance={instance} />
        </Card>
        <Modalshortfalls data={shortData || ''} visible={visible} hideModal={this.hideModal} />
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Page);



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/PageAdd.js